import axios from 'axios';
axios.defaults.timeout = 10000;
axios.defaults.baseURL = '';
const urlList = ['/dev-api/system/vip/login/user','/dev-api/system/vip/login/register', '/dev-api/system/vip/send/sms', '/dev-api/system/vip/reset/password']
// 注册、登录、重置密码、发送验证码、上传图片这五个接口没有带。

//http request 拦截器
axios.interceptors.request.use(
  config => {
    let requrl = config.url.split("?")[0]
    if(urlList.indexOf(requrl) != -1){
      config.headers = {
        'Content-Type': 'application/json',
      }
    }else{
      config.headers = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+window.sessionStorage.getItem('token'),
      }
    }

    return config;
  },
  error => {
    return Promise.reject(err);
  }
);


//http response 拦截器
axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    return Promise.reject(error)
  }
)


/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function get(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.get(url, data)
      .then(response => {
        resolve(response.data);
      })
      .catch(err => {
        reject(err)
      })
  })
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.post(url, data)
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err)
      })
  })
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.patch(url, data)
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err)
      })
  })
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.put(url, data)
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err)
      })
  })
}



// WEBPACK FOOTER //
// ./src/utils/https.js